// Paleta extraída da logo PontoZipar (gradiente azul do ícone de relógio)
export const COLORS = {
  primary: "#0B3DF0",
  primaryDark: "#082BB0",
  primaryLight: "#5AC8FA",
  primaryBg: "#EAF1FF",

  accent: "#5AC8FA",

  danger: "#EF4444",
  dangerBg: "#FEF2F2",
  warning: "#F59E0B",
  warningBg: "#FFFBEB",
  success: "#16A34A",
  successBg: "#F0FDF4",
  info: "#0B3DF0",
  infoBg: "#EAF1FF",

  sidebarBg: "#00134D",
  sidebarBorder: "rgba(255,255,255,0.10)",
  sidebarText: "rgba(255,255,255,0.70)",
  sidebarTextLight: "rgba(255,255,255,0.45)",
  sidebarActiveBg: "rgba(255,255,255,0.12)",
  // Versão um pouco mais escura do `accent` — usada só no contorno sólido da
  // sidebar (AppLayout.js), o azul claro puro ficava forte demais ali.
  sidebarAccent: "#4CAED4",

  white: "#FFFFFF",
  bg: "#F5F8FC",
  surface: "#FFFFFF",
  gray: "#F1F5F9",
  border: "#E4E9F2",
  borderFocus: "#0B3DF0",

  text: "#101A3D",
  textMid: "#5B6480",
  textLight: "#96A0BD",
};

export const RADIUS = {
  sm: 8,
  md: 10,
  lg: 14,
  xl: 18,
};

export const SHADOW = {
  card: "0 1px 3px rgba(16,26,61,0.06), 0 1px 2px rgba(16,26,61,0.04)",
  raised: "0 4px 20px rgba(11,61,240,0.16)",
  focus: "0 0 0 3px rgba(11,61,240,0.14)",
  // Sombra grande e bem suave, baixa opacidade — o efeito "flutuando" dos
  // cards principais, mesma linguagem visual do app mobile (ver
  // mobile/src/theme.js SHADOW.float).
  float: "0 14px 28px rgba(11,22,54,0.10)",
};

// Gradientes reutilizados — espelha mobile/src/theme.js GRADIENT, em formato
// de string CSS em vez de array (aqui não tem LinearGradient de componente,
// é background: direto).
export const GRADIENT = {
  primaryBtn: `linear-gradient(135deg, ${COLORS.primary} 0%, #145CFF 100%)`,
  onda: `linear-gradient(135deg, ${COLORS.primaryDark} 0%, ${COLORS.primary} 100%)`,
};

export const FONT = "'Inter', system-ui, -apple-system, sans-serif";
